import './loading-indicator.scss'
import loaderIcon from '../../assets/images/etihadLoaderLogo.svg'
import spinnerIcon from '../../assets/images/SpinnerCircle.svg'
import { useTranslation } from "react-i18next";


const LoadingIndicator = () => {
	 const { t } = useTranslation(["labels", "errors"], { useSuspense: false });
	return (
		<div className='spinnerdiv'>
			<div>
				<div className='loading__inner'>
					<img src={spinnerIcon} alt="spinner icon" />
					<img src={loaderIcon} alt="loading icon" />
				</div>
				<div className="loading__text">{t('COMMON.LOADING')}</div>
			</div>
		</div>
	)
}

export default LoadingIndicator;
